import Introduction from '../../../../components/Shared/Introduction';
import Subtitle from '../../../../components/Shared/Subtitle';

import { Product, Content } from '../../../../types/tour';
import { useGetStartedContext } from '../../../../components/Shared/GetStarted/GetStarted.context';

import introImage from '../../../../images/art.png';

export type Props = {
  setComplete: (stepIndex: number, parentIndex?: number) => void;
  goNext: () => void;
  content: Content;
  image?: string;
};

export const Step1 = ({ setComplete, goNext, content }: Props) => {
  const { state } = useGetStartedContext();

  const initTour = () => {
    setComplete(state.current);
    goNext();
  };
  return (
    <Introduction
      setComplete={initTour}
      product={Product.Chat}
      title={content.title}
      noAuth={true}
      subtitle={<Subtitle content={content?.paragraphs} />}
      image={
        <img src={introImage} alt={content.title} className="hidden md:block" />
      }
    />
  );
};
